import React from "react";
import "../helpCenter/helpCenter.scss";
import { useNavigate } from "react-router-dom";

export default function HelpCenter() {
  const navigate = useNavigate();
  return (
    <div className="help-center">
      <div className="help-header">
        <h1>How can we help you?</h1>
        <p>Find answers in our support resources.</p>
      </div>

      <div className="help-cards">
        <div
          className="help-card"
          onClick={() => navigate("/help-center/get-started")}
        >
          <div className="card-icon">🚀</div>
          <h3>Get Started</h3>
          <p>
            Learn how to start using the platform and configure the basic
            settings.
          </p>
        </div>

        <div
          className="help-card"
          onClick={() => navigate("/help-center/FAQs")}
        >
          <div className="card-icon">❓</div>
          <h3>FAQ</h3>
          <p>
            Browse frequently asked questions and common solutions to issues.
          </p>
        </div>
      </div>
    </div>
  );
}
